<template>
  <div class="ttc">
    <input
      v-if="searchable"
      v-model="query"
      type="text"
      class="ttc-search"
      placeholder="Buscar unidade ou equipe…"
    >

    <div class="ttc-list custom-scroll">
      <team-tree-branch
        :nodes="visibleTree"
        tag="label"
        :is-chosen="isChosen"
        :is-covered="isCovered"
        :is-selectable="isSelectable"
        @pick="toggle"
      >
        <template #before="{ node }">
          <span
            class="ttc-check"
            :class="{
              'is-on': isChosen(node.id) && !isCovered(node.id),
              'is-covered': isCovered(node.id)
            }"
          />
        </template>
      </team-tree-branch>

      <p
        v-if="visibleTree.length === 0"
        class="ttc-empty"
      >
        {{ query.trim() ? "Nenhuma unidade ou equipe encontrada." : emptyLabel }}
      </p>
    </div>
  </div>
</template>

<script>
import TeamTreeBranch from "./TeamTreeBranch.vue";

export default {
  components: { "team-tree-branch": TeamTreeBranch },
  props: {
    tree: { type: Array, default: () => [] },
    modelValue: { type: Array, default: () => [] },
    searchable: { type: Boolean, default: true },
    coverDescendants: { type: Boolean, default: false },
    cascadeDescendants: { type: Boolean, default: false },
    emptyLabel: { type: String, default: "Nenhuma equipe disponível." },
    isSelectable: { type: Function, default: () => true }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      query: ""
    };
  },
  computed: {
    marksDescendants() {
      return this.coverDescendants || this.cascadeDescendants;
    },
    coveredIds() {
      if (!this.marksDescendants || this.modelValue.length === 0) return [];

      const covered = [];

      const collect = (nodes) => {
        (nodes || []).forEach((node) => {
          covered.push(String(node.id));
          collect(node.children);
        });
      };

      const walk = (nodes) => {
        (nodes || []).forEach((node) => {
          if (this.isChosen(node.id)) collect(node.children);
          else walk(node.children);
        });
      };

      walk(this.tree);

      return covered;
    },
    visibleTree() {
      const q = this.query.trim().toLowerCase();
      if (!q) return this.tree;
      const filter = (nodes) =>
        (nodes || []).reduce((out, node) => {
          const children = filter(node.children);
          const selfMatch = (node.name || "").toLowerCase().includes(q);
          if (selfMatch || children.length) {
            out.push({
              ...node,
              children: selfMatch ? node.children : children
            });
          }
          return out;
        }, []);
      return filter(this.tree);
    }
  },
  methods: {
    isCovered(id) {
      return this.coveredIds.includes(String(id));
    },
    isChosen(id) {
      return this.modelValue.some((c) => String(c) === String(id));
    },
    descendantIds(id) {
      const found = [];

      const collect = (nodes) => {
        (nodes || []).forEach((node) => {
          found.push(node.id);
          collect(node.children);
        });
      };

      const walk = (nodes) => {
        for (const node of nodes || []) {
          if (String(node.id) === String(id)) {
            collect(node.children);
            return true;
          }

          if (walk(node.children)) return true;
        }

        return false;
      };

      walk(this.tree);

      return found;
    },
    toggle(id, checked) {
      const affected = this.cascadeDescendants
        ? [id, ...this.descendantIds(id)]
        : [id];

      const next = this.modelValue.filter(
        (c) => !affected.some((a) => String(a) === String(c))
      );

      if (checked) next.push(...affected);

      this.$emit("update:modelValue", next);
    }
  }
};
</script>

<style scoped>
.ttc-search {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #e5e2ef;
  background: #faf9fd;
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
  color: #3a3a3a;
  outline: none;
  margin-bottom: 8px;
}
.ttc-search:focus {
  border-color: #9a397d;
}
.ttc-list {
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #e5e2ef;
  border-radius: 12px;
  padding: 6px 4px;
  background: #ffffff;
}
.ttc-check {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  border: 1.5px solid #d9d5e6;
  flex: none;
  position: relative;
  background: #ffffff;
}
.ttc-check.is-covered {
  border-color: #c4bdd8;
  background: #c4bdd8;
}
.ttc-check.is-covered::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.ttc-check.is-on {
  border-color: #4f3f82;
  background: #4f3f82;
}
.ttc-check.is-on::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.ttc-empty {
  padding: 18px;
  text-align: center;
  color: #9a9a9a;
  font-size: 13px;
  margin: 0;
}
</style>
